import { NgModule } from '@angular/core';
import { RequisitoMainComponent } from './requisito-main.component';
import { RequisitoFormComponent } from './requisito-form.component';
import { RequisitoRoutes } from './requisito.routes';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
    declarations: [
        RequisitoMainComponent,
        RequisitoFormComponent
    ],
    imports: [
        RequisitoRoutes,
        SharedModule
    ],
    exports: [
        RequisitoMainComponent
    ]
})

export class RequisitoModule { }
